export default "__VITE_ASSET__66b11c59__"